import { render, staticRenderFns } from "./trems.vue?vue&type=template&id=705410a9"
import script from "./trems.vue?vue&type=script&lang=js"
export * from "./trems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports